import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PersonRemoveAlt1OutlinedIcon from "@mui/icons-material/PersonRemoveAlt1Outlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { EmptyState } from "@/core/ui";

const TYPE_LABELS = { MASC: "Masculino", FEM: "Feminino", MISTA: "Mista" };

const ManageRankDialog = ({
  open,
  seasonName,
  categories,
  selectedCategory,
  onChangeCategory,
  search,
  onChangeSearch,
  usersInRank,
  usersOutRank,
  onRemove,
  onAdd,
  onClose,
}) => (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Gerenciar ranking da temporada</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary">
            Temporada: <strong>{seasonName || "-"}</strong>
          </Typography>

          <FormControl fullWidth size="small">
            <InputLabel id="manage-rank-category-label">Categoria</InputLabel>
            <Select
              labelId="manage-rank-category-label"
              value={selectedCategory}
              label="Categoria"
              onChange={(e) => onChangeCategory(e.target.value)}
            >
              {(categories ?? []).map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name} - {TYPE_LABELS[cat.type] ?? cat.type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            size="small"
            label="Buscar usuário"
            value={search}
            onChange={(event) => onChangeSearch(event.target.value)}
            fullWidth
          />

          <Grid container spacing={1.5}>
            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  p: 1.2,
                  height: "100%",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ mb: 1 }}
                >
                  <Typography sx={{ fontWeight: 900 }}>No ranking</Typography>
                  <Chip
                    size="small"
                    label={`${usersInRank.length}`}
                    sx={{ fontWeight: 800 }}
                  />
                </Stack>

                <Stack spacing={0.8}>
                  {usersInRank.length ? (
                    usersInRank.map((user) => (
                      <Paper
                        key={user.id}
                        elevation={0}
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 1.5,
                          p: 1,
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={1}
                        >
                          <Typography noWrap sx={{ fontWeight: 800, minWidth: 0 }}>
                            {user.name}
                          </Typography>
                          <Button
                            size="small"
                            color="error"
                            variant="outlined"
                            startIcon={<PersonRemoveAlt1OutlinedIcon />}
                            onClick={() => onRemove(user.id)}
                            sx={{ textTransform: "none", fontWeight: 700 }}
                          >
                            Remover
                          </Button>
                        </Stack>
                      </Paper>
                    ))
                  ) : (
                    <EmptyState
                      icon={<PeopleOutlineIcon sx={{ fontSize: 34 }} />}
                      title="Nenhum usuário no ranking"
                      description="Nenhum usuário no ranking para este filtro."
                      sx={{ py: 2 }}
                    />
                  )}
                </Stack>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  p: 1.2,
                  height: "100%",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ mb: 1 }}
                >
                  <Typography sx={{ fontWeight: 900 }}>Fora do ranking</Typography>
                  <Chip
                    size="small"
                    label={`${usersOutRank.length}`}
                    sx={{ fontWeight: 800 }}
                  />
                </Stack>

                <Stack spacing={0.8}>
                  {usersOutRank.length ? (
                    usersOutRank.map((user) => (
                      <Paper
                        key={user.id}
                        elevation={0}
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 1.5,
                          p: 1,
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={1}
                        >
                          <Typography noWrap sx={{ fontWeight: 800, minWidth: 0 }}>
                            {user.name}
                          </Typography>
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<PersonAddAltOutlinedIcon />}
                            onClick={() => onAdd(user.id)}
                            sx={{ textTransform: "none", fontWeight: 700 }}
                          >
                            Adicionar
                          </Button>
                        </Stack>
                      </Paper>
                    ))
                  ) : (
                    <EmptyState
                      icon={<PeopleOutlineIcon sx={{ fontSize: 34 }} />}
                      title="Nenhum usuário disponível"
                      description="Nenhum usuário disponível fora do ranking."
                      sx={{ py: 2 }}
                    />
                  )}
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
);

export default ManageRankDialog;
